/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, $Sprite, CanBeSignals, $GraphicsBox, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Button} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {uiMenuEmitter, UIMenuBarEvents} from '@gongxigames/framework/slotV2/ui/services/UIMenu/UIMenuEmitter';
import {$PopupBg} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Popup';
import {COLOR_POPUP_BG} from '@gongxigames/framework/slotV2/ui/ui-ruby/CONSTANTS';
import {Store} from '@gongxigames/framework/core';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {uiMenuStore} from '@gongxigames/framework/slotV2/ui/services/UIMenu/uiMenuStore';
import {Rectangle} from 'pixi.js';

export type UIMenuBarConfig = Record<keyof UIMenuBarEvents, {
    hide?: boolean;
}>;

export type UIMenuBarPops = CanBeSignals<{
    show: boolean;
    config: UIMenuBarConfig;
}>;
const HIT_AREA = new Rectangle(-160/2, -90/2, 160, 90);

export const $UIMenuBar: FC<UIMenuBarPops> = (props)=> {
    const config= getProp(props.config);
    const buttons = Object.entries(config)
        .filter(([, value]) => !value.hide)
        .map(([key]) => key as keyof UIMenuBarEvents);
    const fullWidth = Store.computed(() => slotStore.stage_isPortrait.value ? 980 : 1120);
    const sectionWidth = Store.computed(() => fullWidth.value / buttons.length);
    const numberOfSections = Store.computed(() => buttons.length);
    const positionY = Store.computed(() => slotStore.stage_isPortrait.value ? 160 : 130);
    const height = Store.computed(() => slotStore.stage_isPortrait.value ? 190 : 160);
    const responsiveBG = Store.computed((): ResponsiveConf => ({
        box: {x: '0%', y: '100%', width: '100%', height: `${height.value}px`},
        translate: {y: `-${height.value}px`}
    }));
    const responsivePopupBg = Store.computed((): ResponsiveConf => ({
        updateHeight: true,
        updateWidth: true,
        box: {x: '50%', y: '100%', width: `${sectionWidth.value * numberOfSections.value}px`, height: '90px'},
        translate: {x: '-50%', y: `-${positionY.value}px`}
    }));

    return <$Container
        visible={props.show}
    >
        <$GraphicsBox
            responsive={responsiveBG}
            responsiveBoxSize
            boxColor={COLOR_POPUP_BG}
        />
        <$PopupBg responsive={responsivePopupBg}>
            {
                buttons.map((state, i) => {
                    const responsiveButton = Store.computed((): ResponsiveConf => ({
                        box: {x: `${(i + 0.5) * sectionWidth.value}px`, y: '50%'}
                    }));
                    const responsiveSprite = Store.computed((): ResponsiveConf => ({
                        box: {x: `${(i + 1) * sectionWidth.value}px`, y: '50%'}
                    }));

                    return <$Container>
                        <$Button
                            name={`icon_${state}`}
                            hitArea={HIT_AREA}
                            action={() => uiMenuEmitter.emit(state)}
                            responsive={responsiveButton}
                            visible={!config[state].hide}
                            highlighted={Store.computed(() => uiMenuStore.activePage.value === state)}
                        />
                        <$Sprite
                            responsive={responsiveSprite}
                            visible={i + 1 < numberOfSections.value}
                            name={state}
                            anchor={0.5}
                            texture={'panel_separator'}
                        />
                    </$Container>;
                })
            }
        </$PopupBg>
    </$Container>;
};